<!-- ╔═══════════════════════════════════════════╗
     ║     SECTION 5 : DU DIGITAL AU PHYSIQUE    ║
     ╚═══════════════════════════════════════════╝ -->
<template>
  <section id="physique" class="py-16 py-md-15 my-md-10">
    <v-container>
      <v-row justify="center" class="text-center">
        <v-col cols="12" md="10">
          <h2
            :class="[
              'font-weight-bold mb-8',
              $vuetify.breakpoint.mdAndUp ? 'text-h2' : 'text-h4',
            ]"
          >
            {{ $t("section_5_physique_title") }}
          </h2>
          <p
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'text-h5' : 'text-h6',
              'font-weight-light text-left',
            ]"
          >
            {{ $t("section_5_physique_text") }}
          </p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<!-- ╔═════════════════╗
     ║     SCRIPTS     ║
     ╚═════════════════╝ -->

<script>
import Vue from "vue";

export default Vue.extend({
  name: "digitalToPhysical-section",
});
</script>
